import React from 'react';
import styles from './index.module.css';

const StaticContent = ({ description = "" }) => {
  return (
    <div className={styles.holiday_container}>
      <p>Your holiday, your way.</p>
      {description && <p>{description}</p>}
    </div>
  );
};

export default StaticContent;
